<ng-container *ngIf="hasActiveSession; else noSession">
    <div class="wrapper">
        <div class="wrapper__header">
            <app-header></app-header>
            ddddd<app-breadcrumbs></app-breadcrumbs>
        </div>
        <div class="wrapper__body">
            <router-outlet></router-outlet> 
        </div>
        <div class="wrapper__footer">
            <app-footer></app-footer>
        </div>
    </div>
    <loader></loader>
    <app-toast #toast></app-toast>
</ng-container>

<ng-template #noSession>
    <div>Loading...</div>
</ng-template>
